export default {
  widgetSettings: {
    header: {
      feature: "Widget Settings",
      heading: "Control your widget settings and preferences",
    },
    tabs: {
      preview: "Preview",
      location: "Widget Location",
      privacy: "Privacy Details",
      emailInstallation: "Email Installation",
      smsInstallation: "SMS Installation",
    },
    preview: {
      title: "Preview of the widget on your Shopify store",
      description:
        "See below for a preview of how your consent collection widget looks. Depending on the location of the customer, they will see one of the below options:",
      titles: {
        emailSoftOptIn: "Email: Soft opt-in consent",
        emailSoftOptOut: "Email: Explicit opt-in consent",
        emailImpliedConsent: "Email: Implied consent / No consent required",
        smsSoftOptIn: "SMS: Soft opt-in consent",
        smsExplicitOptIn: "SMS: Explicit opt-in consent",
      },
      trailingContent: {
        title: "Preview your 'Click here' link",
        description:
          "Click to view the marketing information your customer is presented with.",
        cta: "View",
        smsOptInTitle: "See image for a preview of this widget variation",
        smsOptInDescription:
          "Your widget is customised to use your company information and privacy details.",
      },
      modal: {
        title: "Preview of your privacy policy from your widget",
        description:
          'See below for a preview of the information your customer is presented with when they click "Click here" in the widget',
      },
      poweredBy: {
        title: "Toggle Powered By Dataships",
        description:
          'If you do not wish to have the "Powered By Dataships" text enabled on your consent collection widget, you can turn it off here.',
        success: "Setting Changed.",
      },
    },
    privacyDetails: {
      alert: {
        title: "Important Message",
        description:
          "Please ensure your privacy policy URL and privacy email address are accurate. These will appear to your customers on the widget and must be correct.",
      },
      policy: {
        title: "Privacy Policy URL",
        description:
          "Enter the URL where your privacy policy is located on your website.",
        formLabel: "Privacy Policy URL",
        placeholder: "https://myshop.com/policies/privacy-policy",
        cta: "Update URL",
        error: "Privacy policy URL is required",
        success: "Privacy policy URL updated",
      },
      email: {
        title: "Privacy Email Address",
        description:
          "Enter the contact email address where customers can contact you regarding any data privacy concerns or questions.",
        formLabel: "Contact Email Address",
        placeholder: "contact@myshop.com",
        cta: "Update Email",
        error: "Privacy email is required",
        success: "Privacy email updated",
      },
    },
    installation: {
      header: {
        widget: {
          title: "Add the Dataships extension to your checkout",
          description:
            "If you need to add the Dataships extension to your checkout again, please see the instructions below.",
          instructions: {
            heading:
              "How to add the Dataships' extension to your Shopify Checkout?",
          },
        },
      },
      widget: {
        copyToClipboard: "Copy to clipboard",
        copiedToClipboard: "Copied!",
        notification: "Copied to your clipboard.",
      },
      tryAgain: "Try again",
      supportSection: "Was this helpful?",
    },
  },
  integration: {
    header: {
      feature: "Integration Settings",
      heading: "Control your integration settings and preferences",
    },
    tabs: {
      klaviyoKey: "Klaviyo API Key",
      klaviyoPhoneNumbers: "Klaviyo Phone Numbers",
      klaviyoLists: "Klaviyo Lists",
      shopifyApp: "Shopify App",
    },
    klaviyoKey: {
      title: "Klaviyo Authentication",
      description:
        "See below for instructions on how to update the Klaviyo private key associated with Dataships.",
      invalidPrivateKey: "Invalid Private Key, please try again.",
      blankPrivateKey: "Private key cannot be blank",
      inputLabel: "Private Key *",
      inputPlaceholder: "Please enter your private key here",
      tooltip:
        "We treat your Private API key like a password and store it securely",
      cta: "Update",
      instructions: {
        title: "How to create a new Klaviyo Private Key for Dataships",
        step1:
          "Click <1>here</1> to sign into Klaviyo to create a Private API Key ",
        step2: "Name the API Key e.g. <1>Dataships Updated Key</1>",
        step3:
          "Click the <1>Grant applications full access for every API scope</1>",
        step4: "Click <1>Create</1>",
        step5:
          "Your Private Key will be displayed. Click the <1>Copy</1> button to copy it to your clipboard",
        step6:
          "Return to this screen and paste it in the API Key box and click <1>Update</1>",
      },
      success: "Successfully updated Klaviyo key",
    },
    klaviyoLists: {
      title: "List Setup",
      description:
        "If you would like to change the lists your Dataships verified contacts are sent to in Klaviyo you can do so by clicking 'Update' on the list of your choice below. Simply log in to your Klaviyo and find the list ID of the lists you would like to send your newly verified contacts to.",
      table: {
        emailTitle: "Email Klaviyo Lists",
        smsTitle: "SMS Klaviyo Lists",
        columns: {
          type: "Type",
          name: "Name",
          id: "ID",
          actions: "Actions",
        },
        missingList: {
          name: "ERROR: MISSING_LIST",
          id: "ERROR",
        },
        cta: {
          update: "Update",
          add: "Add",
        },
      },
      missingList: {
        title: "Attention: Missing Klaviyo List(s)",
        description:
          "It appears that one or both of your Klaviyo lists are currently missing. To rectify this, please click the 'Add' button in the table located below and proceed to follow the on-screen instructions. Please contact support if you require any further assistance.",
      },
      emptyState: "No Klaviyo Lists found",
      alert: {
        title: "Important Message",
        description:
          "Please note that you must only change your Dataships single opt in list to another single opt in enabled list and similarly only change your Dataships double opt in list to another double opt in enabled list in Klaviyo.",
      },
      modal: {
        title: "Choose your {{ listType }} List",
        description:
          "<0>Select from your existing Klaviyo lists below. You can also see your lists in Klaviyo <1>here.</1></0>",
        descriptionWarning:
          "Please ensure the list you choose is Single Opt-in enabled. You can do this by accessing the list's Settings in Klaviyo and checking the 'Opt-in Process'.",
        dropdown: {
          placeholder: "Choose a new list",
          title: "Klaviyo Lists",
        },
        doubleOptIn: "Double Opt-in",
        singleOptIn: "Single Opt-in",
        invalidListType: "Invalid list type selected",
        error: "Unable to update '{{ listType }}' list",
        success: "Successfully updated '{{ listType }}' list",
        cta: "Update",
      },
    },
    shopifyApp: {
      datashipsApp: {
        title: "Re-install the Dataships app",
        description:
          "If for any reason you need to re-install the Dataships app, click below to be brought to our App Listing page on the Shopify App Store.",
        cta: "Dataships App",
      },
      shopifySettings: {
        title: "View Dataships app settings in Shopify",
        description:
          "If you would like to see more details on our Shopify app, click below to be brought to the app in your Shopify Admin.",
        cta: "Shopify Settings",
      },
    },
  },
  userManagement: {
    header: {
      feature: "User Management",
      heading: "Account Management",
      description:
        "Here you can add, remove or edit team members who are part of your company.",
    },
    addTeamMemberCta: "Add a team member",
    table: {
      name: "Name",
      email: "Email",
      status: "Status",
      resendInvite: "Resend invite",
      edit: "Edit",
      row: {
        active: "Active",
        inactive: "Inactive",
      },
      empty: "No Team Members found.",
    },
    resendInvite: {
      success: "Invitation resent successfully",
      error: "There was an issue resending the invitation. Please try again.",
    },
    common: {
      form: {
        email: {
          label: "Email Address",
          placeholder: "Insert your company email address",
          errors: {
            empty: "You must supply an email address.",
            workEmail: "You must supply a valid work email address.",
          },
        },
        firstName: {
          label: "First Name",
          empty: "You must supply your first name",
          placeholder: "Insert your first name",
        },
        lastName: {
          label: "Last Name",
          empty: "You must supply your last name",
          placeholder: "Insert your last name",
        },
      },
    },
    add: {
      heading: "Add Team Member",
      description:
        "Fill in the details below to add a team member to your company.",
      form: {
        success: "Successfully added team member",
        error: "There was an issue adding your team member. Please try again.",
      },
      submit: "Add Team Member",
    },
    edit: {
      heading: "Edit Team Member",
      description: "Fill in the details below to edit team members details.",
      form: {
        success: "Successfully updated team member",
        error:
          "There was an issue updating your team member. Please try again.",
      },

      remove: "Remove Team Member",
      submit: "Update Team Member",
    },
    remove: {
      content: "Are you sure you want to remove your team member {{ email }}?",
      cta: "Confirm Remove Team Member",
      success: "Successfully removed team member from your account",
    },
    backButton: "Back ",
  },
  companyProfile: {
    feature: "Company Details",
    heading: "Company Profile",
    description: "These details will be used in your policies.",
    form: {
      companyName: {
        label: "Company Name *",
        empty: "You must supply your company name",
        placeholder: "Insert your company name",
      },
      companyWebsiteUrl: {
        label: "Company Website Name *",
        empty: "You must supply your company website name",
        placeholder: "Insert your company website name",
      },
      companyIndustry: {
        label: "Company Type *",
        empty: "You must supply your company type",
        placeholder: "Insert your company type",
      },
      cta: "Save",
    },
    success: "Successfully updated company profile.",
  },
  billing: {
    header: {
      feature: "Billing",
      heading: "Manage My Plan",
    },
    alerts: {
      success: {
        title: "Congratulations!",
        description:
          "You have approved the charge and have been upgraded to our '{{ tier }}' plan!",
      },
      loading: {
        title: "Fetching Subscription",
        description: "Please wait while we get your new subscription.",
      },
      delay: {
        title: "Fetching Subscription",
        description:
          "It's taking a bit longer to update your subscription in our system. Please refresh the page in a few minutes and if the issue still persists then contact our customer service  <1>here</1>",
      },
      approvalRequired: {
        title: "Charge approval required in {{ billingSystem }}",
        description:
          "You have reached our next plan! Please approve the recurring charge in {{ billingSystem }} to continue using Dataships.",
        cta: "Approve Now",
      },
      declined: {
        title: "Your plan requires an upgrade",
        description:
          "You have exceeded the threshold of your current plan and must upgrade to the next plan in order to continue using Dataships. Please click below to generate your upgraded subscription and follow the subsequent instructions to complete the approval.",
        cta: "Upgrade my Plan",
      },
    },
    subscriptionStatusCard: {
      title: "Subscription Status",
      verifiedContacts:
        "Verified Contacts: <1>{{ verifiedContacts }}</1> of <3>{{ tierThreshold }}</3>",
      currentPlan: "Current Plan: <1>{{ tier }}</1>",
      freeTrial: "Free Trial",
      starter: "Starter",
      plus: "Plus",
      pro: "Pro",
      custom: "Custom",
    },
    billingDetailsCard: {
      title: "Billing Details",
      starterDescription:
        'You are currently on our free Starter subscription. When you exceed the "verified contacts" limit you will move to one of our paid subscriptions where your billing will be handled by Shopify.',
      descriptionStart:
        "Your billing is handled by {{ provider }}. Please log in ",
      descriptionLinkTitle: "here",
      descriptionEnd: "to access more information.",
    },
    noSubscription:
      "Please contact a Sales representative or <1>support@dataships.io</1> if you're interested in purchasing a subscription.",
    modal: {
      title: "Are you sure you want to cancel?",
      descriptionUpper:
        "Once you cancel you will still have access to the verified contacts you have collected, but you will no longer collect new contacts via Dataships.  If you change your mind, you can reactivate your account at any time.",
      descriptionMiddle:
        "If you would like to proceed with canceling your subscription, please select",
      descriptionLower: '"Yes, I want to cancel" below.',
      cancelSubscriptionCta: "Yes, I want to cancel",
    },
    restartSubscription: {
      description:
        "You do not currently have an active subscription. To generate a new subscription please click the link below and subsequently approve the charge via Shopify.",
      support:
        "Alternatively, if you would like to discuss with someone from our team please contact us",
      supportLink: "here.",
      cta: "Generate new subscription",
    },
    cta: {
      customerSupport: "Help",
      cancelSubscription: "Cancel my subscription",
      success: "You have successfully cancelled your subscription",
    },
  },
};
